import React, {useEffect, useState} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import withRouter from "../../components/Common/withRouter";
import {Button, Card, CardBody, Col, Container, FormGroup, Label, Row,} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import {createAdmin, getAdmins, getCompanies, getUsers} from "../../store/actions";

import ObjectColumns from "./ObjectColumns";
import {notification} from "antd";
import Preloader from "../../components/Preloader/Preloader";
import Error from "../../components/Error/Error";
import Nulled from "../../components/Null/Nulled";
import PaginationComponent from "../../components/PaginationComponent";

const Index = props => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.Company.isLoading);
    const error = useSelector((state) => state.Company.error);
    const array = useSelector((state) => state.Company.array);
    const arrayCount = useSelector((state) => state.Company.arrayCount);


    const [skip, setSkip] = useState(0)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        let item = {
            skip: skip,
            limit: limit
        }
        dispatch(getCompanies(item))
    }, [dispatch, skip, limit])


    const handlePagination = (newSkip) => {
        setSkip(newSkip);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={process.env.REACT_APP_PROJECT_NAME}
                                 breadcrumbItem="კომპანიები"/>
                    {isLoading ? (
                        <Preloader/>
                    ) : error ? (
                        <Error/>
                    ) : (
                        <Row>
                            {
                                array.length > 0
                                    ?
                                    <>
                                        <Col lg={12} style={{overflowX:'auto'}}>
                                            <ObjectColumns
                                                array={array}
                                            />
                                        </Col>
                                        <PaginationComponent
                                            skip={skip}
                                            limit={limit}
                                            totalItems={arrayCount}
                                            handlePageClick={handlePagination}
                                        />

                                    </>
                                    : <Nulled/>
                            }
                        </Row>
                    )}


                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(Index);
